module.exports = __webpack_public_path__ + "media/images/riders/FABIAN_GIGER-2f00780279554cc8cce54107109f4265.png";